import React from "react";
import summaryStyle from "./summaryStyle";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

type ContractualPartnerDataProps = {
  formData: Record<string, any>;
  title: string;
};

const ContractualPartnerData = ({ formData, title }: ContractualPartnerDataProps) => {
  const opposingPartyType = formData.opposingPartyType;
  const contractualPartner = opposingPartyType === "opposingPartyLegalEntity" ? formData.opposingPartyLegalEntity.organization : formData.opposingPartyPerson;
  const contractualPartnerEmail =
    opposingPartyType === "opposingPartyLegalEntity" ? formData.opposingPartyLegalEntity.organization.mainEmail.email : formData.opposingPartyPerson.email;
  const contractualPartnerAddress =
    opposingPartyType === "opposingPartyLegalEntity" ? formData.opposingPartyLegalEntity.organization.address : formData.opposingPartyPerson.residenceAddress;

  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h6"}>{title}</Typography>
      </Grid>
      {opposingPartyType === "opposingPartyLegalEntity" && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"name"} sx={summaryStyle.scrollToAnchor} />
            Name Unternehmen
          </Grid>
          <Grid size={12}>
            {formData.opposingPartyLegalEntity.organization.legalName}
          </Grid>
        </>
      )}
      {opposingPartyType === "opposingPartyPerson" && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"gender"} sx={summaryStyle.scrollToAnchor} />
            Anrede
          </Grid>
          <Grid size={12}>
            {formData.opposingPartyPerson.gender === "male" ? "Herr" : "Frau"}
          </Grid>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"givenName"} sx={summaryStyle.scrollToAnchor} />
            Vorname
          </Grid>
          <Grid size={12}>
            {formData.opposingPartyPerson.givenName}
          </Grid>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"familyName"} sx={summaryStyle.scrollToAnchor} />
            Nachname
          </Grid>
          <Grid size={12}>
            {formData.opposingPartyPerson.familyName}
          </Grid>
        </>
      )}
      {contractualPartnerAddress.streetAddress && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"streetAddress"} sx={summaryStyle.scrollToAnchor} />
            Straße und Hausnummer
          </Grid>
          <Grid size={12}>
            {contractualPartnerAddress.streetAddress}
          </Grid>
        </>
      )}
      {contractualPartnerAddress.postalCode && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"postalCode"} sx={summaryStyle.scrollToAnchor} />
            Postleitzahl
          </Grid>
          <Grid size={12}>
            {contractualPartnerAddress.postalCode}
          </Grid>
        </>
      )}
      {contractualPartnerAddress.addressLocality && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"addressLocality"} sx={summaryStyle.scrollToAnchor} />
            Ort
          </Grid>
          <Grid size={12}>
            {contractualPartnerAddress.addressLocality}
          </Grid>
        </>
      )}
      {contractualPartnerAddress.postOfficeBoxNumber && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"postOfficeBoxNumber"} sx={summaryStyle.scrollToAnchor} />
            Postfach
          </Grid>
          <Grid size={12}>
            {contractualPartnerAddress.postOfficeBoxNumber}
          </Grid>
        </>
      )}
      {contractualPartnerAddress.postOfficeBoxPostalCode && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"postOfficeBoxPostalCode"} sx={summaryStyle.scrollToAnchor} />
            Postfach PLZ
          </Grid>
          <Grid size={12}>
            {contractualPartnerAddress.postOfficeBoxPostalCode}
          </Grid>
        </>
      )}
      {contractualPartnerAddress.postOfficeBoxAddressLocality && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"postOfficeBoxAddressLocality"} sx={summaryStyle.scrollToAnchor} />
            Postfach Ort
          </Grid>
          <Grid size={12}>
            {contractualPartnerAddress.postOfficeBoxAddressLocality}
          </Grid>
        </>
      )}
      {contractualPartnerEmail && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"email"} sx={summaryStyle.scrollToAnchor} />
            E-Mail-Adresse
          </Grid>
          <Grid size={12}>
            {contractualPartnerEmail}
          </Grid>
        </>
      )}
      {contractualPartner.telephone && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"telephone"} sx={summaryStyle.scrollToAnchor} />
            Telefonnummer
          </Grid>
          <Grid size={12}>
            {contractualPartner.telephone}
          </Grid>
        </>
      )}
    </>
  );
};

export default ContractualPartnerData;
